import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export const INDIV_PLACEHOLDER = '{x1x}';
export const TYP_PLACEHOLDER = '{x2x}';
export const BOLD_START = '{x3x}';
export const BOLD_END = '{x4x}';
// Regex patterns to match placeholders
export const INDIV_PLACEHOLDER_REGEX = /\{x1x\}/g;
export const TYP_PLACEHOLDER_REGEX = /\{x2x\}/g;
export const BOLD_START_REGEX = /\{x3x\}/g;
export const BOLD_END_REGEX = /\{x4x\}/g;

@Pipe({
    name: 'replaceindiv',
    standalone: false
})
export class ReplaceindivPipe implements PipeTransform {
  defaultLanguage;
  constructor(public translateService: TranslateService) {}

  transform(text: string, _txtToReplace: string, _secondTxt: string = null): any {
    if (!text) {
      return text || '';
    }

    let resultText;
    this.defaultLanguage = this.translateService.getDefaultLang();
    
    // Replace "indiv" with protected marker
    if (text.search("indiv") == -1) {
      resultText = text;
    } else {
      resultText = text.replace("indiv", INDIV_PLACEHOLDER);
    }
    
    // Handle #typ replacement - use placeholder to protect from translation
    if (resultText.search("#typ") != -1) {
      resultText = resultText.replace("#typ", TYP_PLACEHOLDER);
    }
    return resultText;
  }
}
